/** KAN-724: таблица писем без привязки: дата, отправитель, тема с началом текста, вложения. */
import { Paperclip } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { senderLabel } from '@/lib/emailFormat';
import { formatCheckedAt } from '@/lib/telegramProxyDirectory';
import type { UnmatchedEmailItem } from '@/types/emailMailbox';

interface Props {
  emails: UnmatchedEmailItem[];
  onOpenEmail: (email: UnmatchedEmailItem) => void;
}

export function UnmatchedEmailsTable({ emails, onOpenEmail }: Props): JSX.Element {
  return (
    <div className="overflow-x-auto rounded-lg border bg-white">
      <Table aria-label="Письма без привязки">
        <TableHeader>
          <TableRow>
            <TableHead>Дата</TableHead>
            <TableHead>От</TableHead>
            <TableHead>Тема</TableHead>
            <TableHead className="w-8" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {emails.map((email) => (
            <TableRow
              key={email.id}
              data-testid={`unmatched-row-${email.id}`}
              className="cursor-pointer hover:bg-gray-50"
              tabIndex={0}
              onClick={() => onOpenEmail(email)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onOpenEmail(email);
              }}
            >
              <TableCell className="whitespace-nowrap text-xs text-gray-600">
                {formatCheckedAt(email.created_at)}
              </TableCell>
              <TableCell className="max-w-[260px] truncate text-sm">{senderLabel(email)}</TableCell>
              <TableCell className="max-w-[420px]">
                <div className="truncate text-sm font-medium">{email.subject || '(без темы)'}</div>
                {email.preview && <div className="truncate text-xs text-gray-500">{email.preview}</div>}
              </TableCell>
              <TableCell>
                {email.has_attachments && (
                  <Paperclip className="h-4 w-4 text-gray-500" aria-label="Есть вложения" />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
